/**
 * Globales Event-System für Mutation-Invalidierung
 * Ermöglicht gezieltes Revalidieren von Tab-Daten nach Upload/Delete-Operationen
 */

export type InvalidateScope =
  | "media"
  | "figures"
  | "journey"
  | "sessions"
  | "profile"
  | "all";

interface InvalidateEventDetail {
  scope: InvalidateScope;
  at: number;
}

/**
 * Löst ein Invalidate-Event aus, um betroffene Tabs zu aktualisieren
 */
export const invalidate = (scope: InvalidateScope): void => {
  const event = new CustomEvent<InvalidateEventDetail>("app:invalidate", {
    detail: {
      scope,
      at: Date.now(),
    },
  });
  window.dispatchEvent(event);
};

/**
 * Abonniert Invalidate-Events und ruft Callback auf
 * @param callback Funktion, die bei Invalidate-Events aufgerufen wird
 * @returns Cleanup-Funktion zum Entfernen des Event-Listeners
 */
export const onInvalidate = (
  callback: (scope: InvalidateScope) => void
): (() => void) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<InvalidateEventDetail>;
    if (customEvent.detail?.scope) {
      callback(customEvent.detail.scope);
    }
  };

  window.addEventListener("app:invalidate", handler);
  return () => window.removeEventListener("app:invalidate", handler);
};
